// src/composables/useEditableDetail.js
import { ref } from 'vue';
import { useRouter } from 'vue-router';

export function useEditableDetail(storeMethods, options = {}) {
    const {
        getItemById,
        updateItem,
        deleteItem,
    } = storeMethods;

    const {
        redirectAfterDelete = '/',
        defaultImage = null,
    } = options;

    const router = useRouter();
    const item = ref(null);
    const isEditing = ref(false);

    // **Load the item by ID**
    const loadItem = async (id) => {
        item.value = await getItemById(id);
    };

    // Edit mode
    const startEdit = () => {
        isEditing.value = true;
    };
    const cancelEdit = () => {
        isEditing.value = false;
    };

    // Save changes
    const updateItemAction = async () => {
        await updateItem(item.value);
        isEditing.value = false;
    };

    // Delete the item and navigate back
    const deleteItemAction = async () => {
        await deleteItem(item.value.id);
        router.push(redirectAfterDelete);
    };

    // Handle image upload
    const onImageUpload = (event) => {
        const file = event.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                item.value.image = reader.result || defaultImage;
            };
            reader.readAsDataURL(file);
        }
    };

    return {
        item,
        isEditing,
        loadItem, // Include loadItem in the returned object
        startEdit,
        cancelEdit,
        updateItem: updateItemAction,
        deleteItem: deleteItemAction,
        onImageUpload,
    };
}
